<template>
  <ODialog ref="dialog" :max-width="1000" hideWhenLoading :persistent="isDirty">
    <v-card v-if="row != null">
      <ODialogBar title="Conteúdo do arquivo" @close="dismiss">
        <!-- <v-spacer />
        <v-btn icon target="_blank" :to="'/setup/cameras/' + row.id">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn> -->
      </ODialogBar>
      <v-card-text class="dialog-main dialog-maxh-calc overflow-auto">
        <div class="d-flex flex-column w-full justify-stretch pa-3">
          <div class="d-flex w-full space-between mb-6">
            <OTextField
              class="grow-1 mr-6"
              v-model="row.projectName"
              label="Projeto"
            />
            <OTextField class="grow-1" v-model="row.filename" label="Arquivo" />
          </div>
          <div class="grow-1">
            <v-textarea
              label="Conteúdo"
              :rows="10"
              v-model="row.contents"
              class="monospace-input dense pa-0"
              auto-grow
            />
          </div>
          <ODialogButtons
            class="pa-6"
            txtApply="Salvar"
            @apply="save"
            @cancel="dismiss"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import go from 'oderon-vue/models/go'

export default {
  components: {},
  data() {
    return {
      row: null,
      id: null,
      isLoading: false,
      isDirty: false
    }
  },
  methods: {
    open(id) {
      this.id = id
      if (this.id != null) {
        this.$refs.dialog.$loading(() => this.fetchData())
      } else {
        this.row = {}
      }
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      let row = await go.get('project-files/' + this.id)
      this.row = row
    },
    save() {
      let { id, projectName, filename, contents } = this.row
      this.$refs.dialog.$apply({ id, projectName, filename, contents })
    },
    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style lang="sass"></style>
